import type {CopilotMarkdownExtension} from '@github-ui/copilot-markdown/extension'

import {type NodeMeta, YamlBlockExtension} from '../../yaml-block-extension'
import {DraftIssueBlock, type DraftIssueBlockProps} from './DraftIssueBlock'

const instance = new (class extends YamlBlockExtension<DraftIssueBlockProps> {
  override get dataAttribute(): `data-${string}` {
    return 'data-draft-issue-block'
  }

  override isSupported(node: NodeMeta): boolean {
    return node.lang === 'yaml' && node.type === 'draft-issue'
  }

  override extractProps(node: NodeMeta): DraftIssueBlockProps {
    return {
      yaml: node.value,
      isStreaming: node.isStreaming ?? false,
    }
  }

  override createComponent(props: DraftIssueBlockProps): React.ReactNode {
    return <DraftIssueBlock {...props} />
  }
})()

export default function draftIssueExtension(): CopilotMarkdownExtension {
  return instance
}
